export const jarvisPrimeDashboardConstants = {
  RESET_DASHBOARD_DATA: "RESET_DASHBOARD_DATA",

  PRIME_PORTFOLIO_ALLOCATIONS_API: "prime/portfolio/allocations",
  PRIME_PORTFOLIO_ALLOCATIONS_RESPONSE: "PRIME_PORTFOLIO_ALLOCATIONS_RESPONSE",
  PRIME_PORTFOLIO_ALLOCATIONS_REQUEST: "PRIME_PORTFOLIO_ALLOCATIONS_REQUEST",
  PRIME_PORTFOLIO_ALLOCATIONS_SAGA: "PRIME_PORTFOLIO_ALLOCATIONS_SAGA",

  PRIME_PORTFOLIO_OVERVIEW_API: "prime/portfolio/overview",
  PRIME_PORTFOLIO_OVERVIEW_REQUEST: "PRIME_PORTFOLIO_OVERVIEW_REQUEST",
  PRIME_PORTFOLIO_OVERVIEW_RESPONSE: "PRIME_PORTFOLIO_OVERVIEW_RESPONSE",
  PRIME_PORTFOLIO_OVERVIEW_SAGA: "PRIME_PORTFOLIO_OVERVIEW_SAGA",

  PRIME_PORTFOLIO_PERFORMANCE_API: "prime/portfolio/performance",
  PRIME_PORTFOLIO_PERFORMANCE_REQUEST: "PRIME_PORTFOLIO_PERFORMANCE_REQUEST",
  PRIME_PORTFOLIO_PERFORMANCE_RESPONSE: "PRIME_PORTFOLIO_PERFORMANCE_RESPONSE",
  PRIME_PORTFOLIO_PERFORMANCE_SAGA: "PRIME_PORTFOLIO_PERFORMANCE_SAGA",

  PRIME_PORTFOLIO_CHART_API: "prime/portfolio",
  PRIME_PORTFOLIO_CHART_REQUEST: "PRIME_PORTFOLIO_CHART_REQUEST",
  PRIME_PORTFOLIO_CHART_RESPONSE: "PRIME_PORTFOLIO_CHART_RESPONSE",
  PRIME_PORTFOLIO_CHART_SAGA: "PRIME_PORTFOLIO_CHART_SAGA",

  PRIME_PORTFOLIO_SECTOR_API: "prime/portfolio/sector",
  PRIME_PORTFOLIO_SECTOR_REQUEST: "PRIME_PORTFOLIO_SECTOR_REQUEST",
  PRIME_PORTFOLIO_SECTOR_RESPONSE: "PRIME_PORTFOLIO_SECTOR_RESPONSE",
  PRIME_PORTFOLIO_SECTOR_SAGA: "PRIME_PORTFOLIO_SECTOR_SAGA",

  PRIME_PORTFOLIO_MARKET_API: "prime/portfolio/market-cap",
  PRIME_PORTFOLIO_MARKET_REQUEST: "PRIME_PORTFOLIO_MARKET_REQUEST",
  PRIME_PORTFOLIO_MARKET_RESPONSE: "PRIME_PORTFOLIO_MARKET_RESPONSE",
  PRIME_PORTFOLIO_MARKET_SAGA: "PRIME_PORTFOLIO_MARKET_SAGA",

  CUSTOMER_STORIES_SAGA: "CUSTOMER_STORIES_SAGA",
  CUSTOMER_STORIES_REQUEST: "CUSTOMER_STORIES_REQUEST",
  CUSTOMER_STORIES_RESPONSE: "CUSTOMER_STORIES_RESPONSE",
  CUSTOMER_STORIES_API: "v1/home/testimonial",

  WELCOME_VIDEO_SAGA: "WELCOME_VIDEO_SAGA",
  WELCOME_VIDEO_REQUEST: "WELCOME_VIDEO_REQUEST",
  WELCOME_VIDEO_RESPONSE: "WELCOME_VIDEO_RESPONSE",
  WELCOME_VIDEO_API: "v1/home/welcome-youtube",

  PRIME_PORTFOLIO_ALERT_API: "prime/stocks/pending-stocks-transaction",
  PRIME_PORTFOLIO_ALERT_SAGA: "PRIME_PORTFOLIO_ALERT_SAGA",
  PRIME_PORTFOLIO_ALERT_REQUEST: "PRIME_PORTFOLIO_ALERT_REQUEST",
  PRIME_PORTFOLIO_ALERT_RESPONSE: "PRIME_PORTFOLIO_ALERT_RESPONSE",

  PRIME_PORTFOLIO_PENDING_TRANSACTION_API:
    "prime/stocks/prime-pending-stocks-transaction-details",
  PRIME_PORTFOLIO_PENDING_TRANSACTION_SAGA:
    "PRIME_PORTFOLIO_PENDING_TRANSACTION_SAGA",
  PRIME_PORTFOLIO_PENDING_TRANSACTION_REQUEST:
    "PRIME_PORTFOLIO_PENDING_TRANSACTION_REQUEST",
  PRIME_PORTFOLIO_PENDING_TRANSACTION_RESPONSE:
    "PRIME_PORTFOLIO_PENDING_TRANSACTION_RESPONSE",

  PORTFOLIO_ARCHIVE_API:
    "prime/stocks/prime-archive-pending-stocks-transaction",

  PORTFOLIO_GENERATE_API: "/prime/stocks/prime-rms-rebalance-call",
  PRIME_REPAIR_TRANSACTION_API: "/prime/stocks/prime-repair-stocks-transaction",

  DASHBOARD_REFRESH_SAGA: "DASHBOARD_REFRESH_SAGA",

  FINAL_PORTFOLIO_CONFIRMATION: "prime/stocks/prime-confirmation",
};
